import AiTypes from './types';

/** ****************************
 * Fetch sample queries
 ***************************** */

export const fetchSamples = (appId, stageId) => ({
  type: AiTypes.FETCH_SAMPLE_QUERIES_START,
  payload: { appId, stageId },
});

export const fetchSamplesSuccess = (payload) => ({
  type: AiTypes.FETCH_SAMPLE_QUERIES_SUCCESS,
  payload,
});

export const fetchSamplesFailure = (error) => ({
  type: AiTypes.FETCH_SAMPLE_QUERIES_FAILURE,
  payload: error,
});

/** ****************************
 * Fetch ai response
 ***************************** */

export const fetchAiResponse = ({ appId, prompt, stageId }) => ({
  type: AiTypes.FETCH_AI_RESPONSE_START,
  payload: { appId, prompt, stageId },
});

export const fetchAiResponseSuccess = (payload) => ({
  type: AiTypes.FETCH_AI_RESPONSE_SUCCESS,
  payload,
});

export const fetchAiResponseFailure = (error) => ({
  type: AiTypes.FETCH_AI_RESPONSE_FAILURE,
  payload: error,
});

/** ****************************
 * Update chat history
 ***************************** */
export const updateChatHistory = (payload) => ({
  type: AiTypes.UPDATE_CHATHISTORY,
  payload,
});

/** ****************************
 * Reset state
 ***************************** */
export const resetState = () => ({
  type: AiTypes.RESET_STATE,
});
